import React, { useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ScrollToTop from "../component/ScrollToTop";
import ContactModal from "../component/ContactModal";

export default function Contact() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [input, setInput] = useState({
    fname: "",
    lname: "",
    email: "",
    mobileno: "",
    msg: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const handleInputs = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (statusMessage) {
      setStatusMessage(null);
    }
  };

  const validate = () => {
    const newErrors = {};
    const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const MOBILE_REGEX = /^[0-9+\s-]{7,15}$/;

    if (!input.fname.trim()) {
      newErrors.fname = "First name is required";
    }
    if (!input.lname.trim()) {
      newErrors.lname = "Last name is required";
    }
    if (!input.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!EMAIL_REGEX.test(input.email.trim())) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!input.mobileno.trim()) {
      newErrors.mobileno = "Phone number is required";
    } else if (!MOBILE_REGEX.test(input.mobileno.trim())) {
      newErrors.mobileno = "Please enter a valid phone number (7-15 digits)";
    }
    if (!input.msg.trim()) {
      newErrors.msg = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validate()) {
      return;
    }

    setIsLoading(true);
    setStatusMessage(null);

    try {
      const payload = {
        fname: input.fname.trim(),
        lname: input.lname.trim(),
        email: input.email.trim(),
        mobileno: input.mobileno.trim(),
        msg: input.msg.trim(),
      };

      const response = await fetch(
        "https://back234genxmeta.com/api/auth/Q09OVEFDVERFVEFJTFM=",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json().catch(() => null);

      if (response.ok) {
        setStatusMessage({
          type: "success",
          text:
            data?.message ||
            "Thank you! Your message has been sent successfully. We will get in touch with you soon.",
        });
        setInput({
          fname: "",
          lname: "",
          email: "",
          mobileno: "",
          msg: "",
        });
        setErrors({});
      } else {
        setStatusMessage({
          type: "error",
          text:
            data?.message ||
            data?.error ||
            `Failed to submit form (Status: ${response.status}). Please try again.`,
        });
      }
    } catch (error) {
      console.error("API error:", error);
      setStatusMessage({
        type: "error",
        text: "Unable to connect to the server. Please check your network or try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="section_padding bg-black hero_padding hero_padding">
          <div className="container ">
            <div className="row py-md-5 py-3 mt-lg-0 mt-md-5 mt-0 g-lg-4 g-3 align-items-center">
              <div className="col-xl-5 col-lg-7">
                <h1 className="heading-1 mb-xl-5 mb-3">
                  Let's Initiate Your Project Repository
                </h1>
                <p className="font_14 text-white">
                  Drop us a line and one of our techies will be in touch with
                  you.
                </p>
                <div className="mt-4">
                  <p className="font_16 text-white fw-bold mb-2">
                    Call Us:
                  </p>
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(0, 210, 255, 0.15)", color: "#00d2ff", border: "1px solid rgba(0, 210, 255, 0.3)", fontSize: "12px" }}>India</span>
                      <a href="tel:+918860132221" className="contact-phone-link fw-semibold">
                        +91 88601 32221
                      </a>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(0, 210, 255, 0.15)", color: "#00d2ff", border: "1px solid rgba(0, 210, 255, 0.3)", fontSize: "12px" }}>Dubai</span>
                      <a href="tel:+971501855369" className="contact-phone-link fw-semibold">
                        +971 50 185 5369
                      </a>
                    </div>
                  </div>
                </div>

                <div className="mt-3 pt-3 border-top border-secondary border-opacity-25">
                  <p className="font_14 text-white mb-1">
                    <span className="text-secondary me-2">Email:</span>
                    <a href="mailto:us@genxmeta.com" className="contact-phone-link fw-semibold">
                      us@genxmeta.com
                    </a>
                  </p>
                  <p className="font_14 text-white mb-0">
                    <span className="text-secondary me-2">Website:</span>
                    <a href="https://www.genxmeta.com" target="_blank" rel="noopener noreferrer" className="contact-phone-link fw-semibold">
                      www.genxmeta.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-12 offset-xl-2">
                <form onSubmit={handleSubmit} className="row gy-1 gx-3" noValidate>
                  {statusMessage && (
                    <div className="col-12 mb-3">
                      <div
                        className={`alert ${
                          statusMessage.type === "success"
                            ? "alert-success bg-success bg-opacity-25 text-white border-success"
                            : "alert-danger bg-danger bg-opacity-25 text-white border-danger"
                        } d-flex align-items-center justify-content-between py-2 px-3 rounded`}
                        role="alert"
                      >
                        <div className="font_14">{statusMessage.text}</div>
                        <button
                          type="button"
                          className="btn-close btn-close-white ms-2"
                          aria-label="Close"
                          onClick={() => setStatusMessage(null)}
                        ></button>
                      </div>
                    </div>
                  )}

                  <div className="col-md-6">
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className={`form-control rounded-left ${
                          errors.fname ? "is-invalid border-danger" : ""
                        }`}
                        id="firstName"
                        placeholder="First Name"
                        name="fname"
                        value={input.fname}
                        onChange={handleInputs}
                        disabled={isLoading}
                      />
                      <label htmlFor="firstName">First Name</label>
                      {errors.fname && (
                        <div className="text-danger font_12 mt-1 ps-1">
                          {errors.fname}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className={`form-control ${
                          errors.lname ? "is-invalid border-danger" : ""
                        }`}
                        id="lastName"
                        placeholder="Last Name"
                        name="lname"
                        value={input.lname}
                        onChange={handleInputs}
                        disabled={isLoading}
                      />
                      <label htmlFor="lastName">Last Name</label>
                      {errors.lname && (
                        <div className="text-danger font_12 mt-1 ps-1">
                          {errors.lname}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className={`form-control ${
                          errors.email ? "is-invalid border-danger" : ""
                        }`}
                        id="email"
                        placeholder="Email address"
                        name="email"
                        value={input.email}
                        onChange={handleInputs}
                        disabled={isLoading}
                      />
                      <label htmlFor="email">Email address</label>
                      {errors.email && (
                        <div className="text-danger font_12 mt-1 ps-1">
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating mb-3">
                      <input
                        type="tel"
                        className={`form-control ${
                          errors.mobileno ? "is-invalid border-danger" : ""
                        }`}
                        id="phone"
                        placeholder="Phone Number"
                        name="mobileno"
                        value={input.mobileno}
                        onChange={handleInputs}
                        disabled={isLoading}
                      />
                      <label htmlFor="phone">Phone Number</label>
                      {errors.mobileno && (
                        <div className="text-danger font_12 mt-1 ps-1">
                          {errors.mobileno}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating mb-3">
                      <textarea
                        className={`form-control ${
                          errors.msg ? "is-invalid border-danger" : ""
                        }`}
                        placeholder="Message"
                        id="message"
                        name="msg"
                        style={{ height: "120px" }}
                        value={input.msg}
                        onChange={handleInputs}
                        disabled={isLoading}
                      />
                      <label htmlFor="message">Message</label>
                      {errors.msg && (
                        <div className="text-danger font_12 mt-1 ps-1">
                          {errors.msg}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12 mt-lg-2 mt-2">
                    <button
                      type="submit"
                      className="btn genxmeta_button font_14 fw-bold w-100 rounded d-flex align-items-center justify-content-center gap-2"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>

                  <p className="contact_para mt-4 font_14">
                    By submitting, you consent to Genxmeta processing your
                    information in accordance with our Privacy Policy. We take
                    your privacy seriously. You can opt out of email updates at
                    any time.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="section_padding location_bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <h2 className="heading-2 text-white">
                  Our Global Offices
                </h2>
                <p className="sub_para contact_para">
                  Connecting and delivering robust technology solutions across time zones with local presence and global expertise.
                </p>
              </div>
            </div>
            <div className="row g-lg-4 g-3 mt-3">
              <div className="col-lg-6 col-md-6">
                <div className="office_location_card p-4 rounded-4 h-100">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h4 className="heading-4 text-white fw-bold mb-0">Dubai Office</h4>
                    <span className="badge rounded-pill px-3 py-2" style={{ background: "rgba(0, 210, 255, 0.15)", color: "#00d2ff", border: "1px solid rgba(0, 210, 255, 0.3)" }}>UAE</span>
                  </div>
                  <p className="font_14 text-white mb-2 fw-medium">Ras Al Khaimah</p>
                  <p className="sub_para contact_para mb-3">
                    Al Shohada Road, Al Hamra Industrial Zone - FZ,<br />
                    Ras Al Khaimah, United Arab Emirates
                  </p>
                  <div className="pt-3 border-top border-secondary border-opacity-25 d-flex flex-column gap-2">
                    <p className="sub_para contact_para mb-0 d-flex align-items-center gap-2">
                      <span className="text-white fw-semibold">Phone:</span>
                      <a href="tel:+971501855369" className="contact-phone-link fw-bold">
                        +971 50 185 5369
                      </a>
                    </p>
                    <p className="sub_para contact_para mb-0 d-flex align-items-center gap-2">
                      <span className="text-white fw-semibold">Email:</span>
                      <a href="mailto:us@genxmeta.com" className="contact-phone-link fw-bold">
                        us@genxmeta.com
                      </a>
                    </p>
                    <p className="sub_para contact_para mb-0 d-flex align-items-center gap-2">
                      <span className="text-white fw-semibold">Website:</span>
                      <a href="https://www.genxmeta.com" target="_blank" rel="noopener noreferrer" className="contact-phone-link fw-bold">
                        www.genxmeta.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6">
                <div className="office_location_card p-4 rounded-4 h-100">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h4 className="heading-4 text-white fw-bold mb-0">India Office</h4>
                    <span className="badge rounded-pill px-3 py-2" style={{ background: "rgba(0, 210, 255, 0.15)", color: "#00d2ff", border: "1px solid rgba(0, 210, 255, 0.3)" }}>India</span>
                  </div>
                  <p className="font_14 text-white mb-2 fw-medium">Noida</p>
                  <p className="sub_para contact_para mb-3">
                    Genxmeta ABC Tower, Assotech Business Cressterra,<br />
                    Sector 135, Noida - 201305
                  </p>
                  <div className="pt-3 border-top border-secondary border-opacity-25 d-flex flex-column gap-2">
                    <p className="sub_para contact_para mb-0 d-flex flex-wrap align-items-center gap-2">
                      <span className="text-white fw-semibold">Phone:</span>
                      <a href="tel:+918860132221" className="contact-phone-link fw-bold">
                        +91 88601 32221
                      </a>
                    </p>
                    <p className="sub_para contact_para mb-0 d-flex align-items-center gap-2">
                      <span className="text-white fw-semibold">Email:</span>
                      <a href="mailto:us@genxmeta.com" className="contact-phone-link fw-bold">
                        us@genxmeta.com
                      </a>
                    </p>
                    <p className="sub_para contact_para mb-0 d-flex align-items-center gap-2">
                      <span className="text-white fw-semibold">Website:</span>
                      <a href="https://www.genxmeta.com" target="_blank" rel="noopener noreferrer" className="contact-phone-link fw-bold">
                        www.genxmeta.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding section">
          <div className="container">
            <div className="row justify-content-center my-xl-5 my-4">
              <div className="col-lg-6 text-center">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a37b076fcebf5f2b1bc482_MindEvolved_symbol@3x.png"
                  alt="img"
                  className="mb-4 repo_img"
                />
                <h2 className="sub_title text-white mb-xl-4 mb-3">
                  Let's initiate your <br /> project repository
                </h2>
                <p className="sub_para body-regular mb-xl-5">
                  Get in touch with our team today to discuss how we can help
                  your business <br /> spot opportunities and realise potential.
                </p>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  className="btn genxmeta_button font_14 fw-bold"
                >
                  Contact
                </button>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <ContactModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </ScrollToTop>
    </>
  );
}
